import { PLOT_TYPE } from "./indicatorTypes";

/**
 * Lowest and highest value of plots drawn over bars first..last: a plot
 * shifted by N bars shows at bar i the value of bar i - N. Histograms grow
 * from zero, so zero is in their range.
 *
 * @param {Object<string, number[]>} series
 * @param {Array<{ key: string, shift: number, type?: string }>} plots
 * @param {number} first
 * @param {number} last
 * @returns {{ min: number, max: number } | null} null without values in view
 */
export const valueRange = (series, plots, first, last) => {
  let min = Infinity;
  let max = -Infinity;

  plots.forEach(({ key, shift, type }) => {
    const values = series[key];
    const from = Math.max(0, first - shift);
    const to = Math.min(values.length - 1, last - shift);

    for (let index = from; index <= to; index += 1) {
      const value = values[index];

      if (Number.isFinite(value)) {
        min = Math.min(min, value);
        max = Math.max(max, value);
      }
    }

    if (type === PLOT_TYPE.HISTOGRAM && from <= to) {
      min = Math.min(min, 0);
      max = Math.max(max, 0);
    }
  });

  return min <= max ? { min, max } : null;
};

/**
 * @param {Array<{ min: number, max: number } | null>} ranges
 * @returns {{ min: number, max: number } | null} the range covering all of them
 */
export const mergeRanges = (ranges) =>
  ranges.reduce((merged, range) => {
    if (!range) return merged;
    if (!merged) return range;

    return { min: Math.min(merged.min, range.min), max: Math.max(merged.max, range.max) };
  }, null);
